import React, { useEffect, useState } from "react";
import CompanyLogo from "../../common/CompanyLogo";
import { TestimonialsEndpoints } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [page, setPage] = useState(1); // Pagination state
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // To track if more testimonials are available

  const api = Api_Instance.unAuth();

  const GetTestimonials = async (pageNumber) => {
    setIsLoading(true);
    try {
      const TestimonialsResponse = await api(
        "GET",
        `${TestimonialsEndpoints?.GET_TESTIMONIAL_API}?page_size=10&page=${pageNumber}`
      );
      const newTestimonials = TestimonialsResponse?.data?.data;

      if (newTestimonials.length > 0) {
        setTestimonials((prev) => [...prev, ...newTestimonials]);
        setHasMore(newTestimonials.length === 10); // If less than 10 items, assume no more pages
      } else {
        setHasMore(false); // No more testimonials
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  // Initial fetch on component mount
  useEffect(() => {
    GetTestimonials(page);
  }, []);

  const loadMoreTestimonials = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    GetTestimonials(nextPage);
  };

  return (
    <>
      <div className="w-full">
        <CompanyLogo title={"Testimonials Us"} subtitle={"Testimonials"} />
      </div>
      <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
        <h1 className="text-3xl font-semibold p-2 mt-3">
          Testimonials
          <hr className="md:mt-4" />
        </h1>
        <section className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.length > 0 ? (
            testimonials.map(
              (item, index) =>
                item.status && (
                  <div key={index} className="relative">
                    <div className="p-7 rounded-xl text-text_color h-[500px] overflow-auto bg-[#F2F5F8] text-center">
                      <p className="text-md text-start">
                        {item?.description}
                      </p>
                    </div>
                    <div className="w-5 h-5 bg-[#F2F5F8] rotate-45 absolute -mt-3 left-[24px]" />
                    <div className="flex justify-start items-center gap-4 mt-4 ml-3">
                      <div className="w-14 h-14 rounded-full bg-[#F2F5F8]">
                        <img
                          src={`${item?.image}`}
                          alt="User"
                          className="w-full h-full rounded-full"
                        />
                      </div>
                      <div>
                        <h1>{item?.director_name}</h1>
                        <p>
                          {item?.designation}, {item?.brand_name}
                        </p>
                      </div>
                    </div>
                  </div>
                )
            )
          ) : (
            <div>No Testimonial Available</div>
          )}
        </section>

        {hasMore && (
          <div className="mt-5 flex justify-center">
            <button
              className="px-4 py-2 bg-primaryColor text-white rounded-lg"
              onClick={loadMoreTestimonials}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Testimonials;
